import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, View } from "react-native";

import DependencyAvatarCustom from "./DependencyAvatarCustom";
import DependencyDetailCustom from "./DependencyDetailCustom";

export default class DependencyAvatarDetailCustom extends React.Component {
  static propTypes = {
    fullName: PropTypes.string.isRequired,
    dependent: PropTypes.oneOf(["parents", "partner", "children"]).isRequired
  };

  render() {
    const {fullName, dependent } = this.props;

    return (
      <View style={styles.container}>
        <DependencyAvatarCustom dependent={dependent} />
        <View style={styles.detailContainer}>
          <DependencyDetailCustom fullName={fullName} />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flexDirection: "row",
    flexGrow: 1,
    padding: 10,
    paddingEnd: 100,
    width: 0
  },
  detailContainer: {
    marginStart: 15
  }
});
